import AddIcon from '@mui/icons-material/Add';
import CloseIcon from '@mui/icons-material/Close';
import EmailIcon from '@mui/icons-material/Email';
import { DialogActions, DialogContent, DialogTitle } from '@mui/material';
import React, { Fragment, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import qr_code from '../../../assets/images/content/register-devices-qr.png';
import CopyIcon16pxSvg from '../../../assets/images/icons/CopyIcon16pxSvg';
import QuestionIcon16pxSvg from '../../../assets/images/icons/QuestionIcon16pxSvg';
import download_on_the_appstore from '../../../assets/images/logo/app-store.png';
import download_for_window from '../../../assets/images/logo/download-for-windows.png';
import get_it_on_google from '../../../assets/images/logo/get-it-on-googleplay.png';
import avatar_logo from '../../../assets/images/logo/register-devices-logo.png';
import DefaultTooltip from '../../../components/DefaultTooltip';
import {
   ControlpanelErrorButton,
   ControlpanelSecondaryButton,
   ControlpanelSuccessButton,
   ControlpanelWarningButton,
   GrayIconButton,
} from '../../../components/StyledButton';
import { CustomDialog } from '../../../components/StyledComponents';
import { StyledLinkBlue } from '../../../components/StyledLink';
import SendTokenByEmailDialog from './SendTokenByEmailDialog';

const RegisterDevicesDialog = ({ info, onClose }) => {
   const { t } = useTranslation();
   const [generated, setGenerated] = useState(false);
   const [openSendByMail, setOpenSendByMail] = useState(false);
   const [copyValue, setCopyValue] = useState('5770276');
   const handleGenerate = () => {
      setGenerated(true);
   };
   const handleRemoveGenerate = () => {
      setGenerated(false);
   };

   const handleCopyToClipboard = () => {
      navigator.clipboard
         .writeText(copyValue)
         .then(() => {
            toast.success('Copied to clipboard!');
            setTimeout(() => {}, 1500);
         })
         .catch((error) => {
            toast.error(error);
         });
   };

   const handleOpenSendByMail = () => {
      setOpenSendByMail(true);
   };

   const handleCloseSendByMail = () => {
      setOpenSendByMail(false);
   };

   return (
      <Fragment>
         <CustomDialog transitionDuration={300} maxWidth={'xl'} open onClose={onClose} keepMounted>
            <DialogTitle>
               <div className='flex justify-between'>
                  <div className='flex items-center gap-4'>
                     <p className='text-xl font-semibold '>{t('common.generate-a-new-divice-registration-token')}</p>
                     <DefaultTooltip
                        readMore={true}
                        title={t('tool-tip.client-registering-view')}
                        content={
                           <div className='flex flex-col gap-3'>
                              <p>{t('tool-tip.before-record-attendances-in-checkid-facialsense')}</p>
                           </div>
                        }
                     >
                        <QuestionIcon16pxSvg className='fill-[#BDBDBD]' />
                     </DefaultTooltip>
                  </div>
                  <GrayIconButton onClick={onClose}>
                     <CloseIcon />
                  </GrayIconButton>
               </div>
            </DialogTitle>

            <DialogContent>
               <p>{t('common.use-the-registration-code-below-to-register-client-app')}</p>
               <div className='card p-7 mt-3'>
                  <div className='flex gap-5 items-center'>
                     <img src={avatar_logo} alt='' />
                     <div>
                        <p className='text-2xl font-semibold'>
                           {info.firstName}&nbsp;{info.lastName}
                        </p>
                        <p className='text-[#3B82F6]'>Emp Code: ABCDE</p>
                     </div>
                  </div>
                  <div className='pt-5'>
                     {generated ? (
                        <div>
                           <div className='p-4 rounded-md bg-[#EFF6FF]'>
                              <p>{t('common.use-email-function-to-send-this-registration')}</p>
                           </div>
                           <div className='pt-5 flex flex-col items-center'>
                              <p>{t('common.one-time-registration-token')}</p>
                              <div className='card !bg-[#EFF6FF] p-5 mt-3 text-center max-w-[250px]'>
                                 <p>{copyValue}</p>
                                 <StyledLinkBlue className='flex gap-2 cursor-pointer justify-center' onClick={handleCopyToClipboard}>
                                    <CopyIcon16pxSvg />
                                    {t('common.copy-to-clipboard')}
                                 </StyledLinkBlue>
                                 <p>{t('common.token-will-be-valid-until')} 2024-02-26 09:49 AM</p>
                              </div>
                           </div>
                           <div className='pt-3 flex justify-center'>
                              <img src={qr_code} alt='' className='img-responsive' />
                           </div>
                           <div className='flex gap-3 justify-end pt-3'>
                              <ControlpanelErrorButton onClick={handleRemoveGenerate}>
                                 <CloseIcon />
                                 <p>{t('button.remove')}</p>
                              </ControlpanelErrorButton>
                              <ControlpanelWarningButton onClick={handleOpenSendByMail}>
                                 <EmailIcon />
                                 <p>{t('button.email')}</p>
                              </ControlpanelWarningButton>
                           </div>
                        </div>
                     ) : (
                        <div className='flex justify-end'>
                           <ControlpanelSuccessButton onClick={handleGenerate}>
                              <AddIcon />
                              <p>{t('button.generate')}</p>
                           </ControlpanelSuccessButton>
                        </div>
                     )}
                  </div>

                  <div className='pt-5'>
                     <p className='text-center'>CheckID FacialSense Lite clients</p>
                     <div className='flex flex-wrap items-center justify-center gap-5'>
                        <img src={get_it_on_google} alt='get_it_on_google' className='w-[150px]' />
                        <img src={download_for_window} alt='download_for_window' className='w-[150px]' />
                        <img src={download_on_the_appstore} alt='download_on_appstore' className='w-[150px]' />
                     </div>
                  </div>
               </div>
            </DialogContent>

            <DialogActions>
               <div className='flex gap-2 px-4 py-4'>
                  <ControlpanelSecondaryButton onClick={onClose}>
                     <CloseIcon />
                     <p>{t('button.close')}</p>
                  </ControlpanelSecondaryButton>
               </div>
            </DialogActions>
         </CustomDialog>

         {openSendByMail && <SendTokenByEmailDialog onClose={handleCloseSendByMail} />}
      </Fragment>
   );
};

export default RegisterDevicesDialog;
